export enum StarRatingLabel {
  starRequired = 'Star count is required and cannot be zero'
}
